export default async function signIn({ authToken }) {
  sessionStorage.setItem("authToken", authToken);

  return {
    authToken: authToken,
  };
}
